// ZYN-309: badge de situação cadastral do CNPJ na Receita Federal.
// Ativa → verde · Suspensa/Inapta → âmbar · Baixada/Nula → vermelho.
// `size="sm"` para listas, default para forms/headers.
const STYLES = {
  ok:    { color: '#047857', bg: 'rgba(16,185,129,0.12)', border: 'rgba(16,185,129,0.35)' },
  warn:  { color: '#b45309', bg: 'rgba(245,158,11,0.12)', border: 'rgba(245,158,11,0.35)' },
  bad:   { color: '#b91c1c', bg: 'rgba(239,68,68,0.12)',  border: 'rgba(239,68,68,0.35)' },
};

function classify(situacao) {
  const s = (situacao || '').toLowerCase();
  if (!s) return null;
  if (s.includes('ativa')) return 'ok';
  if (s.includes('suspensa') || s.includes('inapta')) return 'warn';
  if (s.includes('baixada') || s.includes('nula')) return 'bad';
  return 'warn';
}

export default function SituacaoCadastralBadge({ situacao, size = 'md', showWhenActive = false }) {
  const kind = classify(situacao);
  if (!kind) return null;
  if (kind === 'ok' && !showWhenActive) return null;

  const st = STYLES[kind];
  const pad = size === 'sm' ? 'px-1.5 py-0 text-[10px]' : 'px-2 py-0.5 text-[11px]';
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full font-semibold uppercase tracking-wide ${pad}`}
      style={{ color: st.color, backgroundColor: st.bg, border: `1px solid ${st.border}` }}
      title={`Situação cadastral na Receita Federal: ${situacao}`}
    >
      {kind !== 'ok' && '⚠'} {situacao}
    </span>
  );
}
